export const paths = {
  userManagement: '/usermanagement',
  zoneManagement: '/zonemanagement',
  inhouseLists: '/inhouselists',
  inhouseList: '/inhouselists/:listId',
  transferLists: '/transferlists',
  transferList: '/transferlists/:listId',
  roomingLists: '/roominglists',
  roomingList: '/roominglists/:listId',
  ancillariesLists: '/ancillaries',
  ancillariesList: '/ancillaries/:listId',
  skiOrders: '/skiorders',
  excursions: '/excursions',
  destinationDatabase: '/knowledgedatabase/:tenantId',
  destinationDatabaseSearchResults: '/knowledgedatabase/:tenantId/search',
  destinationDatabaseQuestions: '/knowledgedatabase/:tenantId/questions/:folderId',
  destinationDatabaseQuestion: '/knowledgedatabase/:tenantId/question/:questionId',
  visitingHours: '/visitinghours',
  home: '/',
}

export function buildInhouseListPath(listId: string) {
  return paths.inhouseList.replace(':listId', listId)
}

export function buildTransferListPath(listId: string) {
  return paths.transferList.replace(':listId', listId)
}

export function buildRoomingListPath(listId: string) {
  return paths.roomingList.replace(':listId', listId)
}

export function buildAncillariesListPath(listId: string) {
  return paths.ancillariesList.replace(':listId', listId)
}

export function buildDestinationDatabasePath(tenantId: string) {
  return paths.destinationDatabase.replace(':tenantId', tenantId)
}

export function buildDestinationDatabaseSearchResultsPath(tenantId: string, query: string) {
  return `${paths.destinationDatabaseSearchResults.replace(':tenantId', tenantId)}?query=${encodeURIComponent(query)}`
}

export function buildDestinationDatabaseQuestionsPath(tenantId: string, folderId: string) {
  return paths.destinationDatabaseQuestions.replace(':tenantId', tenantId).replace(':folderId', folderId)
}

export function buildDestinationDatabaseQuestionPath(tenantId: string, questionId: string, query?: string) {
  const path = paths.destinationDatabaseQuestion
    .replace(':tenantId', tenantId)
    .replace(':questionId', questionId)
  return query !== undefined && query.length > 0 ? `${path}?query=${encodeURIComponent(query)}` : path
}
